<span id="mitsTableButtonsPopoverBackdrop" #popoverBackdrop [ngClass]="{'hidden': !opened}" (click)="opened = false">
  <span id="mitsTableButtonsPopoverWrapper" #popoverWrapper>
    <span [ngClass]="{'hidden': !opened}" class="popoverBox"
      [ngStyle]="{'width': (size.w || 300) + 'px', 'height': (size.h || 300) + 'px'}">
      <ng-container *ngFor="let button of buttons; let index = index">
        <span *ngIf="!(button.hidden || (button.hiddenFunc && button.hiddenFunc(optionalData)))" class="mitsTableButton"
          [ngClass]="{'disabled': button.disabled || (button.disabledFunc && button.disabledFunc(optionalData))}"
          (click)="clicked($event, button, index)">
          <mits-icon [name]="button.icon" [ngStyle]="{'color': button.color}">
          </mits-icon>
        </span>
      </ng-container>
    </span>
  </span>
</span>